'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
import InviteSentView, { type SentResult } from './invite/InviteSentView';
import InviteForm from './invite/UsernameInviteForm';
type Props = {
  closeHandler: () => void;
  slug: string;
};
const InviteMembersModal = props => {
  const $ = _c(11);
  const [sent, setSent] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2>Invite to space</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.closeHandler) {
    t1 = <ModalHeader closeHandler={props.closeHandler}>{t0}</ModalHeader>;
    $[1] = props.closeHandler;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.closeHandler || $[4] !== props.slug || $[5] !== sent) {
    t2 = <ModalContent>{sent ? <InviteSentView sent={sent} onClose={props.closeHandler} onInviteAnother={() => setSent(null)} /> : <InviteForm slug={props.slug} onSent={setSent} onCancel={props.closeHandler} />}</ModalContent>;
    $[3] = props.closeHandler;
    $[4] = props.slug;
    $[5] = sent;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.closeHandler || $[8] !== t1 || $[9] !== t2) {
    t3 = <Modal closeHandler={props.closeHandler}>{t1}{t2}</Modal>;
    $[7] = props.closeHandler;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default InviteMembersModal;